<template>  
  <div>
    <Topo :btnLogout="true" :acessoRestritoMenu="true"></Topo>    
    <Migalha label="Área Restrita"></Migalha>    
  </div>
</template>
<script>
import Migalha from "../../components/migalha";
import Topo from "../../components/Topo";

export default {
  name: "area-restrita",
  components: { /*Componentes utilizados*/
    Migalha,
    Topo
  }
};
</script>
